export const webviewTemplateGenerator = <T extends object>(
  template: (data: Partial<T>) => string,
  varsObj: T,
) => {
  return template(varsObj);
};

export const webviewDataInjection = <T extends object>(
  template: string,
  injectionData?: T,
) => {
  if (!injectionData) return '';

  let result = template;

  Object.entries(injectionData).forEach(([key, value]) => {
    result = result.replaceAll(`{{${key}}}`, value);
  });

  return result;
};
